<template>
  <div class="btnBox">
    <div class="leftBtns">
    <button
      style="background-image: url(assets/img/L1.png);"
      :class="{ active: activeButton === 'button1' }"
      @click="Leftclick1"
    >
      
    </button>
    <button
      style="background-image: url(assets/img/L2.png);"
      :class="{ active: activeButton === 'button2' }"
      @click="Leftclick2"
    >
      
    </button>
    <button
      style="background-image: url(assets/img/L3.png);"
      :class="{ active: activeBtn3 === true }"
      @click="Leftclick3"
    >
      
    </button>
    <button
      style="background-image: url(assets/img/L5.png);"
      id="leftBtn4"
      :class="{ active: activeL4 === true }"
      @click="Leftclick4"
    >
      
    </button>
    <button
      style="background-image: url(assets/img/L4.png);"
      :class="{ active: activeBtn5 === true }"
      @click=Leftclick5()
    >
      
    </button>
    </div>

    <div class="rightBtns">
      <button
      style="background-image: url(assets/img/R1.png);"
      :class="{ active: activeButton === 'button7' }"
      @click="Rightclick2"
    >
      
    </button>
      <button
      style="background-image: url(assets/img/R2.png);"
      :class="{ active: activeR1 === true }"
      @click="Rightclick1"
    >
    </button>
    <button
    style="background-image: url(assets/img/R3.png);"
      :class="{ active: activeR3 === true }"
      @click="Rightclick3"
    >
      
    </button>
    <button
    style="background-image: url(assets/img/R4.png);"
      :class="{ active: activeR4 === true }"
      @click="Rightclick4"
    >
      
    </button>
    <button
    style="background-image: url(assets/img/R5.png);"
      :class="{ active: activeR5 === true }"
      @click="Rightclick5"
    >
      
    </button>
    </div>

    <div class="baseMapControl">
      <div
        :class="{ mapactive: activeBaseMap === 'hybrid' }"
        @click="changeBaseMap1"
      >
      卫星
      </div>
      <div
        :class="{ mapactive: activeBaseMap === 'topo' }"
        @click="changeBaseMap2"
      >
      地形
      </div>
      <div
        :class="{ mapactive: activeBaseMap === 'streets' }"
        @click="changeBaseMap3"
      >
      街道
      </div>
      <div
        :class="{ mapactive: activeBaseMap === 'streets-night-vector' }"
        @click="changeBaseMap4"
      >
      夜间
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'buttonsControl',
  props: {
    Leftclick1: Function,
    Leftclick2: Function,
    Leftclick3: Function,
    activeBtn3:Boolean,
    Leftclick4: Function,

    Rightclick1: Function,
    Rightclick2: Function,
    Rightclick3: Function,
    Rightclick4: Function,
    Rightclick5: Function,
    activeButton: String,
    activeL4:Boolean,
    activeR1:Boolean,
    activeR3:Boolean,
    activeR4:Boolean,
    activeR5:Boolean,

    changeBaseMap1:Function,
    changeBaseMap2:Function,
    changeBaseMap3:Function,
    changeBaseMap4:Function,
    activeBaseMap: String,
  },
  data(){
    return{
      activeBtn5:false,
    }
  },
  methods:{
    Leftclick5(){
      const baseMapControl=document.querySelector('.baseMapControl');
      if(this.activeBtn5==false){
        baseMapControl.style.transform = "translateX(0vw)";
        baseMapControl.style.opacity = 1;
        baseMapControl.style.scale = 1;
        this.activeBtn5=true;
      }
      else{
        baseMapControl.style.transform = "translateX(-30vw)";
        baseMapControl.style.scale = 0.3;
        baseMapControl.style.opacity = 0;
        this.activeBtn5=false;
      }
    }
  }
}
</script>

<style scoped>
.btnBox{
  width: 100vw;
  position: absolute;
  left: 0;
}
.leftBtns{
  width: 9vw;
  display:flex;
  flex-direction: column;
  position: absolute;
  left: 1vw;
  gap: 2px;
}
.rightBtns{
  width: 9vw;
  display:flex;
  flex-direction: column;
  position: absolute;
  right: 1vw;
  gap: 2px;
}
button {
  width: 9vw;
  height: 9vw;
  background-color: rgba(0, 0, 0, 0.337);
  position: relative;
  color: aqua;
  font-size: 12px;
  z-index: 3;
  background-size: contain;
  background-repeat: no-repeat;
}
button.active {
  background-color: #ffff007c; /* 激活状态颜色 */
}
.baseMapControl{
  top: 23vw;
  left: 11vw;
  display:flex;
  flex-direction: column;
  position: absolute;
  gap: 2px;
  transition: all 0.5s;
  transform: translateX(-30vw);
  opacity: 0;
  scale: 0.3;
}
.baseMapControl div{
  width: 9vw;
  height: 9vw;
  line-height: 9vw;
  background-color: rgba(0, 0, 0, 0.467);
  border: rgb(0, 0, 0);
  border-style:solid;
  border-width: 1px;
  box-shadow: 0.3vw 0.3vw rgba(0, 0, 0, 0.708);
  position: relative;
  color: aqua;
  font-size: 12px;
  z-index: 3;
}
.baseMapControl .mapactive{
  background-color: #ffff007c;
  color: rgb(58, 6, 83);
}
</style>